module.exports = __webpack_public_path__ + "img/square-list.545e898b.svg";